module.exports = __webpack_public_path__ + "img/6_26.0c22a0af.png";